module.exports = __webpack_public_path__ + "img/icon-star1.b34dbe3a.png";